import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/objecttypes/'
const ITEM_ID  = 'obt_id'

export const useObjectTypeStore = defineStore('objecttypes', {
  persist: true,

  state: () => ({
    item: null,
    itemList: [],
    metaItems: null
  }),
  getters: {
    itemListByTheme () {
      let itemsObject = {}
      for (let i = 0, len = this.itemList.length; i < len; i++) {
        const tem = this.itemList[i].obt_tem_id
        if (!itemsObject[tem]) { itemsObject[tem] = [] }
        itemsObject[tem].push(this.itemList[i])
      }
      return itemsObject
    },
    itemListById () {
      let itemsObject = {}
      for (let i = 0, len = this.itemList.length; i < len; i++) {
        itemsObject[this.itemList[i][ITEM_ID]] = this.itemList[i]
      }
      return itemsObject
    }
  },
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) { this.item = item },
    SET_ITEMS (itemList) { this.itemList = itemList },
    RESET_ITEM () { this.item = {} }
  }
})
